<script lang="ts">
	interface IData {
		label?: string;
		avatar?: string;
	}

	export let data: IData = {
		label: "",
		avatar: "",
	};
	export let noTransform = false;

	$: firstLetters = data.label
		.split(" ")
		.map(name => name[0])
		.join("");

</script>

<div class="wx-user">
	{#if data.avatar}
		<img src={data.avatar} alt={data.label} />
	{:else if noTransform}{data.label}{:else}{firstLetters}{/if}
</div>

<style>
	.wx-user {
		width: var(--wx-kanban-user-icon-size);
		height: var(--wx-kanban-user-icon-size);
		border-radius: 50%;
		border: solid var(--wx-kanban-card-background) 2px;
		background: var(--wx-kanban-background);

		color: var(--wx-color-font);
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: var(--wx-font-size);
		overflow: hidden;
	}

	.wx-user img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.wx-user:nth-child(2) {
		transform: translateX(-10px);
	}
	.wx-user:nth-child(3) {
		transform: translateX(-20px);
	}
	.wx-user:nth-child(4) {
		transform: translateX(-30px);
	}

</style>
